export default __webpack_public_path__ + "static/bucketsOFish-503e19cc0a1b4a71eee71c7f2dbcce5d.jpg";